<template>

  <div class="home-wrap">

    <img class="top-img" src="../../../assets/imgs/banner2.jpeg">
    <div class="contact-us-wrap">
      <div class="left-wrap">

        <div class="head-txt">
          联系我们
        </div>
        <div @click="qiehuanTab(index)" :class="currTab == index ?'item-txt item-txt-select':'item-txt'"
             v-for="(txt, index) in menuList">
          {{ txt.text }}
        </div>
      </div>

      <div class="right-wrap">

        <div style="width: 100%;height: 1px;background-color: #333333"></div>

        <div class="text-title">
          当前位置：
          <div class="a-a" @click="goHome">首页</div>
          > {{ menuList[currTab].text }}
          <img class="c-us" src="../../../assets/imgs/serve-phone.png">
          <div class="c-line"></div>
        </div>

        <template v-if="currTab==0">
          <img style="margin-top: 20px" src="../../../assets/imgs/contact-us.png">
          <div class="lxwo-wrap">
            <div class="lxwo-left-wrap">
              <div style="color: #666;font-size: 16px">地址：浙江省杭州市西湖区西溪路525号C楼5295室</div>
              <div style="margin-top: 20px;color: #666;font-size: 16px">电话：13023631525</div>
              <div style="margin-top: 20px;color: #666;font-size: 16px">邮箱：hztskj001@163.com</div>
            </div>
            <div id="container2" class="lxwo-right-wrap"></div>
          </div>
        </template>
        <template v-if="currTab==1">
          <div class="yfpt-w">
            <img src="../../../assets/imgs/white-top.png">
            <div class="title">人力资源</div>
          </div>

          <!--          <p class="content-p">-->
          <!--            公司秉承人才是最大的财富的经营理念，坚持公司与员工共同发展，为员工提供稳定的工作环境、均等的学习成长机会，搭建公平竞争的职业发展舞台。-->
          <!--          </p>-->
          <!--          <p class="content-p">-->
          <!--            公司鼓励员工将个人发展与企业发展紧密结合，用心做事、成就卓越，不断提升工作能力及业务水平，为公司发展贡献自己的智慧和力量。-->
          <!--          </p>-->
          <!--          <p class="content-p">-->
          <!--            伴随着公司的发展，竭诚欢迎各方英才加入我们！-->
          <!--          </p>-->
          <!--          <div style="width: 100%;display: flex;justify-content: center">-->
          <!--            <img style="width: 612px;height: 368px" src="../../../assets/imgs/rlzy-ic.jpg">-->
          <!--          </div>-->
        </template>
        <template v-if="currTab==2">
          <div class="yfpt-w">
            <img src="../../../assets/imgs/white-top.png">
            <div class="title">招聘信息</div>
          </div>

        </template>
        <div style="height: 20px"></div>
        <div id="p1" class="content-w">
        </div>
        <div style="height: 40px"></div>
      </div>
    </div>

  </div>
</template>

<script>
import $ from 'jquery'

export default {
  name: "contactUsFragment",
  data: () => {
    return {
      currTab: 0,
      menuList: [{
        text: '联系我们',
      }, {
        text: '人力资源',
      }, {
        text: '招聘信息',
      }]
    }
  },
  mounted() {
    var map = new BMapGL.Map("container2");
    map.enableScrollWheelZoom(true);
    // 创建地图实例
    var point = new BMapGL.Point(120.117246, 30.273219);
    // 创建点坐标
    map.centerAndZoom(point, 15);
    var marker1 = new BMapGL.Marker(new BMapGL.Point(120.117246, 30.273219));
// 在地图上添加点标记
    map.addOverlay(marker1);
  },
  methods: {
    goHome() {
      this.$router.replace('/home')
    },
    qiehuanTab(i) {
      this.currTab = i
    }
  },
  watch: {
    currTab(vv) {
      $("#p1").empty()
      if (vv == 2) {
        $("#p1").append(this.$store.state.zpxx[0].detail);
      } else if (vv == 1) {
        $("#p1").append(this.$store.state.rlzy[0].detail);
      }
    }
  }
}
</script>

<style lang="less" scoped>

.home-wrap {
  width: 1400px;
  min-width: 100%;
  display: flex;
  align-items: center;
  background-color: white;
  flex-direction: column;

  .top-img {
    width: 100%;
    min-width: 1400px;
  }

}

.contact-us-wrap {
  width: min-content;
  min-height: 100%;
  padding-top: 10px;
  //min-width: min-content;
  display: flex;
  background-color: white;
  justify-content: center;

  .left-wrap {
    width: 230px;
    display: flex;
    flex-direction: column;

    .head-txt {
      background-color: #063979;
      width: 100%;
      height: 60px;
      line-height: 60px;
      color: white;
      font-size: 18px;
      padding-left: 20px;
    }

    .item-txt {
      width: 100%;
      background-color: #DEDFE0;
      height: 50px;
      line-height: 50px;
      padding-left: 20px;
      font-size: 16px;
      color: #666666;
      margin-top: 2px;
    }

    .item-txt-select {
      color: #143772;
      border-bottom: 1px #143772 solid;
    }
  }

  .right-wrap {
    display: flex;
    flex-direction: column;
    width: 970px;
    margin-left: 10px;

    .text-title {
      color: #666666;
      font-size: 16px;
      display: flex;
      height: 34px;
      align-items: center;
      position: relative;

      .c-us {
        position: absolute;
        right: 0;
        bottom: 0;
      }

      .a-a {
        margin-left: 5px;
        margin-right: 5px;
        font-size: 16px;
        color: #666666;
      }

      .a-a:hover {
        text-decoration: underline;
        color: #22B5A8;
      }

      .c-line {
        background-color: #333333;
        height: 1px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 20px;
      }
    }


    .yfpt-w {
      width: 100%;
      background-image: linear-gradient(to right, #1565A8, #84B2EF);
      position: relative;
      display: flex;
      margin-top: 20px;
      flex-direction: column;

      img {
        top: 20px;
        left: 30px;
        position: absolute;
      }

      .title {
        margin-left: 45px;
        color: white;
        margin-right: 20px;
        margin-bottom: 20px;
        margin-top: 40px;
        font-size: 18px;
      }
    }

    .lxwo-wrap {
      width: 100%;
      display: flex;
      margin-top: 40px;
      margin-bottom: 40px;
      align-items: center;
      justify-content: space-between;

      .lxwo-left-wrap {
        display: flex;
        flex-direction: column;
      }

      .lxwo-right-wrap {
        width: 565px;
        height: 305px;
        border-radius: 3px;
        border: #D0E2FF solid 3px;

      }
    }

    .content-p {
      //text-indent: 2em;
      font-size: 16px;
      color: #333333;
      margin-top: 10px;
      width: 100%;
    }

    .content-w {
      width: 100%;
    }
  }
}
</style>
